import React, { useState } from 'react';
import Styles from './TemplatesSection.module.scss';
import Navigation from '../Navigation/Navigation';
import arrowLeft from '../../../assets/landingpage/ArrowLeft.png';
import arrowRight from '../../../assets/landingpage/ArrowRight.png';
import { FaLinkedin } from 'react-icons/fa';

import erik from './images/erik.jpeg';
import chris from './images/chris.jpeg';
import sonja from './images/sonja.jpeg';
import mellisa from './images/mellisa.jpeg';

const navigations = [
  {
    text: 'Save 20 Hours/Week (and Thousands of Dollars)',
    content: {
      avatar: erik,
      description:
        'Tremendously bullish on Vocable.ai. The amount of time and energy automation has saved me on Linkedin (to mere minutes a day) is amazing!',
      name: 'Erik Pupo',
      role: 'Director At Guidehouse',
    },
  },
  {
    text: '10x Your Content Without Losing Your Voice',
    content: {
      avatar: chris,
      description:
        'This tool has massively elevated my ability DAILY to deliver valuable content to my audiences. Congratulations, absolutely inspiring! 🏆',
      name: 'Chris Begin',
      role: 'Founder of Begin Recruitment',
    },
  },
  {
    text: '2X Your Business Growth with Strategic Content',
    content: {
      avatar: sonja,
      description:
        'I love Vocable.ai. It has changed the way I do my Social Media Marketing. I have learned so much from Iman, the creator of Vocable. The number of lead generations and actual calls for meetings to set up contracts has increased immeasurably.',
      name: 'Sonja Biggs',
      role: 'Ph.D. Certified Life Coach',
    },
  },
  {
    text: 'Streamline everything in one structured workflow',
    content: {
      avatar: mellisa,
      description:
        'I enjoyed my free trial and look forward to seeing it evolve. I love the thoughtful arrangement of the dashboard and insight into the content plans and campaigns. So much room to play with features. Great job',
      name: 'Melissa Colman',
      role: 'AI Marketing Agency',
    },
  },
];

const TemplatesSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className={Styles.toolkit}>
      <div className={Styles.toolkit__header}>
        <div className={Styles.toolkit__header__heading}>
          <img src={arrowLeft} alt="left" />
          <h2>
            Why Creators, Marketers, and Businesses Are Switching to Vocable
          </h2>
          <img src={arrowRight} alt="right" />
        </div>
      </div>

      <div className={Styles.toolkit__grid}>
        <div className={Styles.toolkit__grid__left}>
          <Navigation
            navigations={navigations}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
          />
        </div>
        <div className={`${Styles.toolkit__grid__right}`}>
          <div className={Styles.toolkit__grid__right__header}>
            <p className={Styles.toolkit__grid__right__header__text}>
              {navigations[activeIndex].description}
            </p>
          </div>
          <div className={Styles.toolkit__grid__right__social}>
            <div className={Styles.toolkit__grid__right__social__header}>
              <img
                className={Styles.toolkit__grid__right__social__header__avatar}
                src={navigations[activeIndex].content.avatar}
                alt="profile"
              />
              <div
                className={Styles.toolkit__grid__right__social__header_platform}
              >
                <FaLinkedin size={24} style={{ color: '#00A7B7' }} />
                <p>LinkedIn</p>
              </div>
            </div>
            <div className={Styles.toolkit__grid__right__social__content}>
              <div
                style={{
                  color: '#00A7B7',
                  fontSize: '32px',
                  fontWeight: '800',
                }}
              >
                <span>{'“'}</span>
              </div>
              <p>{navigations[activeIndex].content.description}</p>
            </div>
            <div className={Styles.toolkit__grid__right__social__footer}>
              <p style={{ fontSize: '1rem', fontWeight: '600' }}>
                {navigations[activeIndex].content.name}
              </p>
              <p style={{ fontSize: '0.8rem' }}>
                {navigations[activeIndex].content.role}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatesSection;
